module.exports = __webpack_public_path__ + "media/images/corporation_black-c858b84a94c229f6765da9bbc5813e28.svg";